// ── Affichage unique des codes de secours après activation TOTP ──
export default function TotpBackupCodes({ codes, onDone, dark }) {
  const colors = dark
    ? { card:'#13141a', border:'#2a2b35', text:'#fff', muted:'#888', accent:'#7c5cfc' }
    : { card:'var(--bg-elevated)', border:'var(--border)', text:'var(--text-1)',
        muted:'var(--text-3)', accent:'var(--accent-light)' };

  const copyAll = () => {
    navigator.clipboard?.writeText(codes.join('\n'));
  };

  return (
    <div style={{ textAlign:'center' }}>
      <p style={{ color:colors.muted, fontSize:13, marginBottom:16, lineHeight:1.5 }}>
        Conservez ces codes de secours dans un endroit sûr. Chacun ne peut être utilisé
        qu'une seule fois pour vous connecter si vous perdez l'accès à votre application d'authentification.
        Ils ne seront plus jamais affichés.
      </p>
      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:8, marginBottom:16,
        background:colors.card, border:`1px solid ${colors.border}`, borderRadius:10, padding:16 }}>
        {codes.map(c => (
          <div key={c} style={{ fontFamily:'monospace', fontSize:14, fontWeight:700, color:colors.text }}>{c}</div>
        ))}
      </div>
      <div style={{ display:'flex', gap:8, justifyContent:'center' }}>
        <button onClick={copyAll} type="button"
          style={{ padding:'9px 16px', borderRadius:8, border:`1px solid ${colors.border}`,
            background:colors.card, color:colors.muted, cursor:'pointer', fontSize:13 }}>
          Copier tout
        </button>
        <button onClick={onDone} type="button"
          style={{ padding:'9px 20px', borderRadius:8, border:'none',
            background:colors.accent, color:'#fff', cursor:'pointer', fontSize:13, fontWeight:700 }}>
          J'ai noté ces codes
        </button>
      </div>
    </div>
  );
}
